import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";

export default function CourseCatalog() {
  const [courses, setCourses] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    api.courses.list().then(setCourses).catch((e) => setError(e.message));
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-bold mb-1" style={{ color: "#154E93" }}>My Training</h1>
      <p className="text-sm text-gray-500 mb-6">Complete your assigned courses at your own pace</p>

      {error && <div className="mb-4 text-sm bg-red-50 text-red-700 px-3 py-2 rounded">{error}</div>}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {courses.map((c) => {
          const pct = c.lesson_count > 0 ? Math.round((c.completed_count / c.lesson_count) * 100) : 0;
          return (
            <Link
              key={c.id}
              to={`/courses/${c.id}`}
              className="bg-white rounded-lg shadow-sm p-4 hover:shadow-md transition-shadow block"
            >
              {c.category && (
                <div className="text-xs font-medium text-gray-400 uppercase mb-1">{c.category}</div>
              )}
              <h3 className="font-semibold text-lg mb-1" style={{ color: "#154E93" }}>{c.title}</h3>
              <p className="text-sm text-gray-500 mb-2 line-clamp-2">{c.description}</p>
              {(c.state_tags || "").split(",").filter(Boolean).length > 0 && (
                <div className="mb-2">
                  {c.state_tags.split(",").filter(Boolean).map((tag) => (
                    <span key={tag} className="inline-block bg-blue-50 text-blue-700 text-xs px-1.5 py-0.5 rounded mr-1">{tag} compliant</span>
                  ))}
                </div>
              )}
              {c.due_date && (
                <div className={`text-xs mb-2 font-medium ${c.is_overdue ? "text-red-600" : "text-gray-500"}`}>
                  {c.is_overdue ? "⚠ Overdue — was due" : "Due by"} {new Date(c.due_date).toLocaleDateString()}
                </div>
              )}
              <div className="w-full bg-gray-100 rounded-full h-2 mb-1">
                <div
                  className="h-2 rounded-full"
                  style={{ width: `${pct}%`, backgroundColor: c.is_complete ? "#16A34A" : "#154E93" }}
                />
              </div>
              <div className="text-xs text-gray-500">
                {c.completed_count}/{c.lesson_count} lessons complete
                {c.is_complete && <span className="ml-2 text-green-600 font-medium">✓ Completed</span>}
              </div>
            </Link>
          );
        })}
        {courses.length === 0 && (
          <div className="text-gray-400 text-sm">No courses have been assigned yet — check back soon.</div>
        )}
      </div>
    </div>
  );
}
